import { useMemo, useState } from "react";
import { evaluateOrdering } from "../lib/learningEngine";
import { hashSeed, seededShuffle } from "../lib/difficulty";
import type { LearningExercise } from "../types";

// Sortieren: Items deterministisch gemischt anzeigen; Klick haengt ans Ende der Sequenz
// (mit Positionsnummer), erneuter Klick entfernt. Bei vollstaendiger Sequenz wird bewertet.
export function OrderingCard({ exercise, onComplete }: { exercise: LearningExercise; onComplete: (correct: boolean) => void }) {
  const items = exercise.orderItems ?? [];
  const shuffled = useMemo(() => seededShuffle(items, hashSeed(exercise.id)), [exercise.id]);
  const [sequence, setSequence] = useState<string[]>([]);
  const [done, setDone] = useState(false);

  function toggle(item: string) {
    if (done) return;
    setSequence((seq) => {
      const next = seq.includes(item) ? seq.filter((s) => s !== item) : [...seq, item];
      if (next.length === items.length) {
        setDone(true);
        onComplete(evaluateOrdering(items, next));
      }
      return next;
    });
  }

  const correct = done && evaluateOrdering(items, sequence);

  return (
    <section className="ordering-card">
      <h3>{exercise.title}</h3>
      <p className="prompt">{exercise.prompt}</p>
      <div className="ordering-items">
        {shuffled.map((item) => {
          const pos = sequence.indexOf(item);
          return (
            <button
              className={`answer-option ${pos >= 0 ? "is-selected" : ""}`}
              disabled={done}
              key={item}
              onClick={() => toggle(item)}
              type="button"
            >
              <span>{pos >= 0 ? pos + 1 : "+"}</span>
              {item}
            </button>
          );
        })}
      </div>
      {done ? (
        <div className={`feedback-panel ${correct ? "is-correct" : "is-wrong"}`}>
          <strong>{correct ? "Reihenfolge sitzt." : "Nicht ganz."}</strong>
          <p className="subsumtion">Richtige Reihenfolge: {items.join(" → ")}</p>
          {exercise.explanation ? <p>{exercise.explanation}</p> : null}
        </div>
      ) : null}
    </section>
  );
}
